export default __webpack_public_path__ + "static/media/ILPlatform_Programme12-16.687a673e.png";